<template>
  <div class="arquivo-base">
    <transition name="fade-arquivos">
      <ArquivoAnalise
        :objetoArquivo="objetoArquivo"
        @baixar-arquivo="baixarArquivo"
        v-if="componenteAtual.arquivoAnalise"
      />
      <ArquivoAprovado
        :objetoArquivo="objetoArquivo"
        @baixar-arquivo="baixarArquivo"
        v-if="componenteAtual.arquivoAprovado"
      />
      <ArquivoReprovado
        :objetoArquivo="objetoArquivo"
        @baixar-arquivo="baixarArquivo"
        v-if="componenteAtual.arquivoReprovado"
      />
      <ArquivoUpload
        :objetoArquivo="objetoArquivo"
        :barraProgresso="objetoArquivo.barraProgresso"
        @cancelar-arquivo="cancelarArquivo"
        v-if="componenteAtual.arquivoUpload"
      />
      <ArquivoCancelado
        :objetoArquivo="objetoArquivo"
        @baixar-arquivo="baixarArquivo"
        v-if="componenteAtual.arquivoCancelado"
      />
    </transition>
  </div>
</template>

<script>
import ArquivoAnalise from "./ArquivoAnalise";
import ArquivoAprovado from "./ArquivoAprovado";
import ArquivoReprovado from "./ArquivoReprovado";
import ArquivoUpload from "./ArquivoUpload";
import ArquivoCancelado from "./ArquivoCancelado";
import { TIPOS_ARQUIVOS } from "./TiposArquivosEnum";

export default {
  components: {
    ArquivoAnalise,
    ArquivoAprovado,
    ArquivoReprovado,
    ArquivoUpload,
    ArquivoCancelado
  },
  props: {
    tipoArquivo: {
      type: String,
      default: "",
      notes: "Valores aceitos: ANALISE, APROVADO, REPROVADO, UPLOAD e CANCELADO"
    },
    objetoArquivo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    baixarArquivo() {
      this.$emit("baixar-arquivo", this.objetoArquivo.uuid);
    },
    cancelarArquivo() {
      this.$store.dispatch("CANCEL_PENDING_REQUESTS");
    }
  },
  computed: {
    componenteAtual() {
      let tipoArquivoAtual = this.tipoArquivo;

      return {
        arquivoAnalise: tipoArquivoAtual === TIPOS_ARQUIVOS.ANALISE,
        arquivoAprovado: tipoArquivoAtual === TIPOS_ARQUIVOS.APROVADO,
        arquivoReprovado: tipoArquivoAtual === TIPOS_ARQUIVOS.REPROVADO,
        arquivoUpload: tipoArquivoAtual === TIPOS_ARQUIVOS.UPLOAD,
        arquivoCancelado: tipoArquivoAtual === TIPOS_ARQUIVOS.CANCELADO
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.arquivo-base {
  min-width: 97.8%;
  display: block;
}

.fade-arquivos-leave-active {
  position: absolute;
}

.fade-arquivos-enter-active,
.fade-arquivos-leave,
.fade-arquivos-leave-to {
  transition: opacity 0.2s;
}

.fade-arquivos-enter,
.fade-arquivos-leave-to {
  opacity: 0;
}
</style>
